export interface IAnomaly {
  incrementVisitedCount: () => void;
  getVisitedCount: () => number | null;
  getDisableForever: () => boolean | null;
  setDisableForever: () => void;
}

const ANOMALY_INDICATION_COUNT = "ANOMALY_INDICATION_COUNT";
const DISABLE_ANOMALY_INDICATOR = "DISABLE_ANOMALY_INDICATOR";

export class AnomalyIndicatorService implements IAnomaly {
  public get shouldShow() {
    return !this.getDisableForever();
  }

  public getVisitedCount() {
    const value = localStorage.getItem(ANOMALY_INDICATION_COUNT);
    if (value === null || isNaN(Number(value))) {
      localStorage.setItem(ANOMALY_INDICATION_COUNT, "0");
      return 0;
    }
    return Number(value);
  }

  public incrementVisitedCount() {
    const value = this.getVisitedCount() + 1;
    if (
      this.getDisableForever() ||
      window.location.pathname.includes("login") ||
      window.location.pathname.includes("oauth")
    ) {
      return;
    }
    localStorage.setItem(ANOMALY_INDICATION_COUNT, `${value}`);
  }

  public getDisableForever() {
    const value = localStorage.getItem(DISABLE_ANOMALY_INDICATOR);
    if (value === null) {
      localStorage.setItem(DISABLE_ANOMALY_INDICATOR, "false");
      return false;
    }
    return Boolean(value === "true");
  }

  public setDisableForever() {
    localStorage.setItem(DISABLE_ANOMALY_INDICATOR, "true");
  }
}
export default new AnomalyIndicatorService();
